import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/calculation/$assemblyId/calculation')({
    // Only redirects: `/projects/$projectId/calculation/assemblies/$assemblyId` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // Comment notification emails link here with `openCommentsDrawer=true`, so the whole query string goes along.
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/projects/$projectId/calculation/assemblies/$assemblyId',
            params: { projectId: params.projectId, assemblyId: params.assemblyId },
            search: true,
            replace: true,
        });
    },
});
